import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Loader2, History } from "lucide-react";

const money = (v) => `R$ ${Number(v || 0).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const METHOD = { cash: "Dinheiro", card: "Cartão", transferencia: "Transferência/Depósito", pix: "Pix", manual: "Manual", other: "Outro" };

const Table = ({ head, rows, testid }) => (
  <div className="overflow-x-auto rounded border" data-testid={testid}>
    <table className="w-full text-xs">
      <thead className="bg-slate-50"><tr>{head.map((h) => <th key={h} className="px-3 py-2 text-left">{h}</th>)}</tr></thead>
      <tbody>{rows.map((r, i) => <tr key={i} className="border-t">{r.map((c, j) => <td key={j} className="px-3 py-1.5">{c}</td>)}</tr>)}</tbody>
    </table>
  </div>
);

export const NextFitHistoryReport = ({ dfFrom, dfTo }) => {
  const [units, setUnits] = useState([]);
  const [unitId, setUnitId] = useState("");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => { api.get("/units").then(({ data }) => setUnits(data || [])).catch(() => {}); }, []);
  useEffect(() => {
    setLoading(true);
    const q = new URLSearchParams({ date_from: dfFrom, date_to: dfTo, ...(unitId ? { unit_id: unitId } : {}) }).toString();
    api.get(`/reports/nextfit-history?${q}`).then(({ data }) => setData(data)).catch(() => setData(null)).finally(() => setLoading(false));
  }, [dfFrom, dfTo, unitId]);

  return (
    <Card className="p-5 space-y-4" data-testid="nextfit-history-report">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <div className="flex items-center gap-2"><History className="w-5 h-5 text-sky-600"/><h3 className="font-heading text-lg font-black">Histórico financeiro — origem Next Fit</h3></div>
        <select value={unitId} onChange={(e) => setUnitId(e.target.value)} className="h-9 border rounded px-2 text-sm" data-testid="nextfit-history-unit">
          <option value="">Todas as unidades</option>
          {units.map((u) => <option key={u.id} value={u.id}>{u.name}</option>)}
        </select>
      </div>
      <p className="text-xs text-slate-500">Pagamentos importados da Next Fit. Não entram no caixa diário, nos fechamentos nem nos indicadores de faturamento atual.</p>
      {loading && <Loader2 className="w-6 h-6 animate-spin text-slate-400"/>}
      {data && !loading && (
        <>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 text-sm" data-testid="nextfit-history-totals">
            <div className="rounded border p-3"><div className="text-[10px] uppercase text-slate-500">Pagos</div><div className="font-black">{data.paid_count}</div></div>
            <div className="rounded border p-3"><div className="text-[10px] uppercase text-slate-500">Valor pago</div><div className="font-black">{money(data.paid_total)}</div></div>
            <div className="rounded border p-3"><div className="text-[10px] uppercase text-slate-500">Pendentes</div><div className="font-black">{data.pending_count}</div></div>
            <div className="rounded border p-3"><div className="text-[10px] uppercase text-slate-500">Valor pendente</div><div className="font-black">{money(data.pending_total)}</div></div>
          </div>
          <Table testid="nextfit-history-methods" head={["Forma de pagamento", "Qtd", "Total"]} rows={data.by_method.map((m) => [METHOD[m.method] || m.method, m.count, money(m.total)])}/>
          <Table testid="nextfit-history-months" head={["Mês", "Pagos", "Valor pago", "Pendentes", "Valor pendente"]} rows={data.by_month.map((m) => [m.period, m.paid_count, money(m.paid_total), m.pending_count, money(m.pending_total)])}/>
          {data.by_month.length === 0 && <div className="text-sm text-slate-500" data-testid="nextfit-history-empty">Nenhum pagamento Next Fit no período.</div>}
        </>
      )}
    </Card>
  );
};
